/**
 * SA-1077 (UX pass spec move 3): the band's words when a seat holder cannot
 * open the task — the seat, the reason, and the seat's bound roles for the
 * button's title. Pure.
 */
import type { WaitingReason } from './waitingSeat'

export const REASON_WORDS: Record<WaitingReason, string> = {
  not_in_seat: 'you are not in this seat',
  cannot_work: 'you cannot work tasks',
}

export function waitingLine(seat: string, reason: WaitingReason | null): string {
  return reason ? `Waiting on ${seat} · ${REASON_WORDS[reason]}` : `Waiting on ${seat}`
}

/** `null` roles = the definition has not loaded: no title. `undefined` or
 * `[]` = the seat is declared and bound to nothing: open to `tasks:work`. */
export function seatRolesTitle(seatLabel: string, roles: string[] | null | undefined): string | null {
  if (roles === null) return null
  return roles && roles.length > 0
    ? `${seatLabel} is held by ${roles.join(', ')}`
    : `${seatLabel} is open to anyone who can work tasks`
}
